<template>
  <BrandLogo
    :class="$attrs.class"
    img-class="block h-full w-full object-contain brand-logo__image"
  />
</template>

<script>
export default {
  inheritAttrs: false,
}
</script>
